import React, { useState } from 'react';
import { db } from '../firebase/firebase-config';
import { collection, addDoc } from 'firebase/firestore';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';


const CreateDetails = () => {
    const [formData, setFormData] = useState({
        registeredMobileNumber: '',
        name: '',
        creditCardNumber: '',
        expiryDate: '',
        cvv: '',
        providerBank: '',
        cardType: '',
        billGeneratedDate: '',
        billDueDate: '',
        remarks: '',
        referredBy: '',
        rajaRemarks: '',
        userId: localStorage.getItem('userId') // Assuming userId is stored in localStorage
    });

    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleBankChange = (selectedOption) => {
        setFormData({
            ...formData,
            providerBank: selectedOption.value
        });
    };

    const handleCardTypeChange = (e) => {
        setFormData({
            ...formData,
            cardType: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');

        try {
            const docRef = await addDoc(collection(db, 'credit-card-details'), formData);
            navigate('/dashboard/all-details');
            console.log('Document written with ID: ', docRef.id);
            // Reset form or redirect as needed
        } catch (error) {
            console.error('Error adding document: ', error);
            setErrorMessage('An error occurred while creating the details.');
        }
    };

    const bankOptions = [
        { value: 'SBI', label: 'SBI' },
        { value: 'AU', label: 'AU' },
        { value: 'HDFC', label: 'HDFC' },
        { value: 'HSBC', label: 'HSBC' },
        { value: 'ICICI', label: 'ICICI' },
        { value: 'INDIAN', label: 'INDIAN' },
        { value: 'Axis', label: 'Axis' },
        { value: 'Kotak', label: 'Kotak' },
        { value: 'PNB', label: 'PNB' },
        { value: 'Yes', label: 'Yes' },
        { value: 'IndusInd', label: 'IndusInd' },
        { value: 'BoB', label: 'BoB' },
        { value: 'Canara', label: 'Canara' },
        { value: 'Union', label: 'Union' },
        { value: 'IDFC', label: 'IDFC' },
        { value: 'KVB', label: 'KVB' },
        { value: 'Federal', label: 'Federal' },
        { value: 'RBL', label: 'RBL' },
        { value: 'ONE', label: 'ONE' },
        { value: 'STANDARD', label: 'STANDARD' },
        { value: 'INDIAN', label: 'INDIAN' },
    ];

    return (
        <div>
            <h3>Create Credit Card Details</h3>
            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-6 mb-3">
                        <label>Registered Mobile Number</label>
                        <input
                            type="text"
                            className="form-control"
                            name="registeredMobileNumber"
                            value={formData.registeredMobileNumber}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <label>Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <label>Credit Card Number</label>
                        <input
                            type="text"
                            className="form-control"
                            name="creditCardNumber"
                            value={formData.creditCardNumber}
                            onChange={(e) => {
                                const input = e.target.value.replace(/\s+/g, '');
                                if (/^\d{0,16}$/.test(input)) {
                                    const formattedInput = input.replace(/(\d{4})(?=\d)/g, '$1 ');
                                    setFormData({ ...formData, creditCardNumber: formattedInput });
                                }
                            }}
                            maxLength="19"
                            placeholder="1234 5678 1234 5678"
                            required
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <label>Expiry Date (MM/YY)</label>
                        <input
                            type="text"
                            className="form-control"
                            name="expiryDate"
                            value={formData.expiryDate}
                            onChange={handleChange}
                            placeholder="e.g., 12/23"
                            required
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <label>CVV</label>
                        <input
                            type="text"
                            className="form-control"
                            name="cvv"
                            value={formData.cvv}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <label>Provider Bank</label>
                        <Select
                            options={bankOptions}
                            onChange={handleBankChange}
                            placeholder="Select a Bank"
                            isClearable
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <label>Card Type</label>
                        <div>
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="cardType"
                                    id="visa"
                                    value="Visa"
                                    onChange={handleCardTypeChange}
                                    required
                                />
                                <label className="form-check-label" htmlFor="visa">Visa</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="cardType"
                                    id="master"
                                    value="MasterCard"
                                    onChange={handleCardTypeChange}
                                    required
                                />
                                <label className="form-check-label" htmlFor="master">MasterCard</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="cardType"
                                    id="rupay"
                                    value="Rupay"
                                    onChange={handleCardTypeChange}
                                    required
                                />
                                <label className="form-check-label" htmlFor="rupay">Rupay</label>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 mb-3">
                        <label>Bill Generated Date (DD)</label>
                        <input
                            type="text"
                            className="form-control"
                            name="billGeneratedDate"
                            value={formData.billGeneratedDate}
                            onChange={handleChange}
                            placeholder="DD"
                            required
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <label>Bill Due Date (DD)</label>
                        <input
                            type="text"
                            className="form-control"
                            name="billDueDate"
                            value={formData.billDueDate}
                            onChange={handleChange}
                            placeholder="DD"
                            required
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <label>Referred By</label>
                        <input
                            type="text"
                            className="form-control"
                            name="referredBy"
                            value={formData.referredBy}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <label>Remarks</label>
                        <textarea
                            className="form-control"
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleChange}
                            rows="3"
                        ></textarea>
                    </div>
                </div>
                <button type="submit" className="btn btn-primary">Create</button>
            </form>
        </div>
    );
};

export default CreateDetails;
